"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomSurface_1 = require("../atoms/ATLAtomSurface");
var react_native_1 = require("react-native");
var CardListItemTypeEnum_1 = require("../enums/CardListItemTypeEnum");
var ATLAtomImage_1 = require("../atoms/ATLAtomImage");
var ImageResizeModeEnum_1 = require("../enums/ImageResizeModeEnum");
var ATLAtomLabel_1 = require("../atoms/ATLAtomLabel");
var TextAlignmentEnum_1 = require("../enums/TextAlignmentEnum");
var defaultProps = {
    type: CardListItemTypeEnum_1.CardListItemTypeEnum.basic,
    imageBaseProps: {},
    titleLabelBaseProps: {},
    descriptionLabelBaseProps: {},
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.CardWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding: 8px ", "px;\n"], ["\n\tpadding: 8px ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
exports.ContentWrapper = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 8px 16px;\n"], ["\n  padding: 8px 16px;\n"])));
exports.TitleContainer = native_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 8px 16px 0px;\n"], ["\n  padding: 8px 16px 0px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])));
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLCardListItem = function (_a) {
    var image = _a.image, title = _a.title, description = _a.description, placeholderImage = _a.placeholderImage, onPress = _a.onPress, type = _a.type, horizontalMargin = _a.horizontalMargin, imageBaseProps = _a.imageBaseProps, titleLabelBaseProps = _a.titleLabelBaseProps, descriptionLabelBaseProps = _a.descriptionLabelBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var renderImage = function () { return (react_1.default.createElement(ATLAtomImage_1.ATLAtomImage, __assign({ source: image, placeholder: placeholderImage, resizeMode: ImageResizeModeEnum_1.ImageResizeModeEnum.cover, height: theme.HeightImageCard }, imageBaseProps))); };
    var renderTitle = function () { return (react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilyBrand, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightStrong, lineHeight: theme.LineHeightBase, textAlign: TextAlignmentEnum_1.TextAlignmentEnum.left, textCase: theme.TextCaseHeading, textColor: theme.ColorBrand1Default }, titleLabelBaseProps), title)); };
    var renderDescription = function () { return (react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, lineHeight: theme.LineHeightBase, textAlign: TextAlignmentEnum_1.TextAlignmentEnum.left, textCase: theme.TextCaseHeading, textColor: theme.ColorHighContrast }, descriptionLabelBaseProps), description)); };
    var getContentByType = function (localType) {
        switch (localType) {
            case CardListItemTypeEnum_1.CardListItemTypeEnum.basic:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(exports.TitleContainer, null, renderTitle()),
                    react_1.default.createElement(exports.ContentWrapper, null, renderDescription())));
            case CardListItemTypeEnum_1.CardListItemTypeEnum.complete:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    renderImage(),
                    react_1.default.createElement(exports.TitleContainer, null, renderTitle()),
                    react_1.default.createElement(exports.ContentWrapper, null, renderDescription())));
            case CardListItemTypeEnum_1.CardListItemTypeEnum.media:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    renderImage(),
                    react_1.default.createElement(exports.ContentWrapper, null, renderTitle())));
        }
    };
    // Returns complete ATLCardListItem
    return (react_1.default.createElement(exports.CardWrapper, { horizontalMargin: horizontalMargin },
        react_1.default.createElement(react_native_1.TouchableOpacity, { disabled: !onPress, onPress: onPress },
            react_1.default.createElement(ATLAtomSurface_1.ATLAtomSurface, { borderColor: theme.ColorLowContrast, borderRadius: theme.BorderRadiusCard, borderWidth: theme.BorderWidthCard, colorSurface: theme.ColorSurface, opacity: 1 }, getContentByType(type)))));
};
exports.ATLCardListItem.defaultProps = defaultProps;
exports.ATLCardListItem.displayName = 'ATLCardListItem';
var templateObject_1, templateObject_2, templateObject_3;
